export type ApiResponseHouse = {
  id: number,
  shortId: number,
  state: string,
  lat: number,
  lng: number,
  type: string,
  address: string,
  number: number,
  numberOrBlock: string,
  neighborhood: string,
  city: string,
  additionalInfo: string,
  complement: string,
  floor: number,
  forSale: boolean,
  forRent: boolean,
}

export class HouseSummary {
  address: string;
  complement: string;
  neighborhood: string;
  number: number;
  forSale: boolean;
  forRent: boolean;

  constructor(apiResponseHouse: ApiResponseHouse) {
    this.address = apiResponseHouse.address;
    this.complement = apiResponseHouse.complement;
    this.neighborhood = apiResponseHouse.neighborhood;
    this.number = apiResponseHouse.number;
    this.forSale = apiResponseHouse.forSale;
    this.forRent = apiResponseHouse.forRent;
  }
}
